import { Injectable } from '@angular/core';
import {HttpRequestService} from '../shared/services/http-request.service';
import {environment} from '../../environments/environment';


@Injectable()
export class HomeService {

  private getNotificationsUrl = environment.apiUrl + '/Home/GetNotifications';
  private getHomeAnalyticsUrl = environment.apiUrl + '/Home/GetHomeAnalytics';


  constructor(private http: HttpRequestService) {}

  getNotifications() {
    return this.http.get(this.getNotificationsUrl);
  }

  getHomeAnalytics () {

    return this.http.get(this.getHomeAnalyticsUrl);
  }


}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/home/home.service.ts